import {Type} from '@mintdata/mint-kit/api/types/Type';
import {ErrorOrEmpty} from '@mintdata/mint-kit/api/types/Value';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {AByte} from '@mintdata/mint-kit/api/values/AByte';
import {ACurrency} from '@mintdata/mint-kit/api/values/ACurrency';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {BaseCoercionUtil} from '@mintdata/mint-kit/impl/coercionUtils/BaseCoercionUtil';

export class ByteCoercionUtil extends BaseCoercionUtil
{
    constructor()
    {
        super(Type.Byte);
    }

    public toBoolean(from:AByte):ABoolean | ErrorOrEmpty
    {
        return new ABoolean(from.value !== 0);
    }

    public toCurrency(from:AByte):ACurrency | ErrorOrEmpty
    {
        return new ACurrency(from.value);
    }

    public toInteger(from:AByte):AInteger | ErrorOrEmpty
    {
        return new AInteger(from.value);
    }

    public toNumber(from:AByte):ANumber | ErrorOrEmpty
    {
        return new ANumber(from.value);
    }

    public toString(from:AByte):AString | ErrorOrEmpty
    {
        return new AString(from.toString());
    }
}
